__turbopack_context__.v({
  "container": "styles-module__zT4U6W__container",
  "discountLabel": "styles-module__zT4U6W__discountLabel",
});
